export function decodeHtmlString(content: string | undefined) {
  if (!content) {
    return content;
  }

  return (
    new DOMParser().parseFromString(content, 'text/html').documentElement
      .textContent ?? undefined
  );
}
